import { useAssistant } from "#src/contexts/Assistant";
import {
  Button,
  colours,
  type ButtonProps,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { forwardRef } from "react";
import styles from "./AssistantTrigger.module.css";

export type AssistantTriggerProps = ButtonProps;

const cx = classNames.bind(styles);

/** @deprecated Validere Assistant summarization UI; superseded by Stratos. */
export const AssistantTrigger = forwardRef<
  HTMLButtonElement,
  AssistantTriggerProps
>(({ isLoading = false, disabled = false, onClick, ...restProps }, ref) => {
  const isOpen = useAssistant((s) => s.isOpen);
  const setIsOpen = useAssistant((s) => s.setIsOpen);
  const handleClick: ButtonProps["onClick"] = (evt) => {
    setIsOpen(true);
    onClick?.(evt);
  };

  return (
    <Button
      ref={ref}
      variant="ghost"
      icon="sparkle"
      size="xx-small"
      disabled={disabled}
      isLoading={isLoading}
      {...(onClick ? { onClick: handleClick } : {})}
      {...restProps}
      iconProps={{
        size: 18,
        colour: colours.colours.teal[800],
        weight: "fill",
        ...(restProps.iconProps ?? {}),
      }}
      className={cx("button", restProps.className, {
        "button--triggered": isOpen,
      })}
    />
  );
});

AssistantTrigger.displayName = "AssistantTrigger";
